import * as trefikApi from "@/api/trefik-api";
import type { TrefikParams } from "@/prematch/model/trefik/trefik-base";
import { TrefikSports } from "@/prematch/model/enums/trefik"; // Import TrefikSports

// Ensure that sport is of type TrefikSports
interface TrefikParamsWithSport extends TrefikParams {
    sport: TrefikSports;
}

export default function useTrefikApi() {
    const getTrefikLeagues = async (): Promise<string[]> => {
        const response = await trefikApi.getTrefikLeagues();

        return response.SportsLeagues;
    };

    const getTrefikLeagueStats = async (params: TrefikParamsWithSport) => {
        const response = await trefikApi.getTrefikLeagueStats(params);
        return response;
    };

    const getTrefikMatchStats = async (params: TrefikParams) => {
        const response = await trefikApi.getTrefikMatchStats(params);
        return response;
    };

    return {
        getTrefikLeagues,
        getTrefikLeagueStats,
        getTrefikMatchStats,
    };
}
